module.exports = __webpack_public_path__ + "static/media/cooperation.211c7915.jpg";